const requestError = {
  namespaced: true,
  state: {
    interviewError: false
  },
  getters: {
    interviewError: state => state.interviewError
  },
  mutations: {
    setInterviewError: (state, payload) => state.interviewError = payload,
  },
  actions: {
    setInterviewError: ({ commit }, value) => commit('setInterviewError', value),
  }
}
export default requestError;
